<div class="top-section service-page">

    <section class="healthcare-banner instool aashi">
        <div class="container">
            <div class="row hero-img-wrapper zmc">
                <div class="col-lg-7 col-md-7 col-sm-7  col-12 service-heading">
                    <div class="headtext">
                        <h1>Microsoft Azure</h1>
                        <p>Microsoft Azure is a comprehensive cloud computing platform that offers a wide range of
                            services for building, deploying, and managing applications and services through
                            Microsoft-managed data centers</p>

                            <a class="ar_contect-industries-header" 
                            routerLink="/contact-us.html"><span>Contact Us</span></a>

                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                    <div class="right-img frontend-heroimg">
                        <img style="    height: 333px;" src="../../../assets/images/services/11.png" loading="lazy"
                            alt="Ecommerce Website Development Service Header Image">
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="services-row">
    <div class="container">
        <!-- <app-services-content-point [firstMAtchData]="firstMAtch"></app-services-content-point> -->

        <div class="softeare-developemnt-isv-main">
            <div class="row">
                <div class="col-lg-12 headingsec">
                    <h2>Microsoft Azure Databases</h2>
                    <!-- <p>It combines the traditional Office suite of applications with advanced cloud services,
                        collaboration tools, and intelligent capabilities. Here's an overview of its functionality and
                        key features</p> -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li class="mobi">
                            <div class="img-box-isv">
                                <img src="../../../assets/images/services/jpeg-optimizer_20945549.jpg"
                                    loading="lazy" alt="Ecommerce Application Development">

                            </div>
                        </li>
                        <li>
                            <h3>Azure SQL Database</h3>
                            <p>Managed relational database service based on Microsoft SQL Server.
                            </p>
                            <h3>Cosmos DB</h3>
                            <p>Globally distributed, multi-model NoSQL database service.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li>
                            <h3>Azure Database for MySQL and PostgreSQL</h3>
                            <p>Managed services for open-source relational databases.</p>
                        </li>
                        <li>
                            <h3>Azure Synapse Analytics</h3>
                            <p>Unified analytics service for data warehousing and big data analytics.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="quote-box" style="    background-color: #0d052a;">
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <h4>Are You Ready To Discuss Your Project With Us?</h4>
            </div>
            <div class="col-md-3">
                <button routerLink="/hire-react-js-developers.html">Hire Our Experts</button>
            </div>
        </div>
    </div>
</section> -->
<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Networking Services it use</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/virtual-network-2.png" alt="HTML">
                        <h3>Virtual Network</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/vpn-2-removebg-preview.png" alt="CSS">
                        <h3>VPN Gateway</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Javascript">
                        <h3>Azure Load Balance</h3>
                    </li>
                    <!-- <li>
                        <img src="../../../../assets/images/services/common/react.png" alt="React">
                        <h3>React</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/angular.png" alt="Angular">
                        <h3>Angular</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/Vue.png" alt="Vue">
                        <h3>Vue</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/sass.png" alt="Scss">
                        <h3>Scss</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/bootstrap.png" alt="Bootstrap">
                        <h3>Bootstrap</h3>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Storage Services it provieds</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/blob-removebg-preview.png" alt="HTML">
                        <h3>Blob Storage</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/file-removebg-preview.png" alt="CSS">
                        <h3>File Storage</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/queue-removebg-preview.png" alt="Javascript">
                        <h3>Queue Storage</h3>
                    </li>
                    <!-- <li>
                        <img src="../../../../assets/images/services/common/react.png" alt="React">
                        <h3>React</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/angular.png" alt="Angular">
                        <h3>Angular</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/Vue.png" alt="Vue">
                        <h3>Vue</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/sass.png" alt="Scss">
                        <h3>Scss</h3>
                    </li>
                    <li>
                        <img src="../../../../assets/images/services/common/bootstrap.png" alt="Bootstrap">
                        <h3>Bootstrap</h3>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</section>



<!-- <app-why-choose-us></app-why-choose-us> -->

<section class="services-row services-row-new">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Developer Tools and Integration</h2>
                <!-- <p>Here’s what you get when you choose us as your preferred business partner:</p> -->
            </div>
        </div>
        <div class="row  uses-box">
            <div class="col-lg-7 col-md-7 col-sm-12 whychoose-isv uses-conent">
                <ul>
                    <li>
                        <h3>Azure DevOps</h3>
                        <p>Suite of development tools for planning, building, testing, and deploying applications.
                        </p>
                    </li>
                    <li>
                        <h3>Azure Resource Manager</h3>
                        <p>Deployment and management service for Azure resources.
                        </p>
                    </li>
                    <li>
                        <h3>Azure Logic Apps</h3>
                        <p> Workflow orchestration service for integrating applications and automating processes.</p>
                    </li>
                    <li>
                        <h3>Azure API Management</h3>
                        <p>Service for managing APIs, including security, scalability, and analytics.</p>
                    </li>
                    <li>
                        <h3>Azure Arc</h3>
                        <p>Service for managing on-premises, multi-cloud, and edge infrastructure using Azure services.</p>
                    </li>
                    <li>
                        <h3>Azure Blockchain Service</h3>
                        <p> Managed service for building, deploying, and managing blockchain networks.
                            These are just some of the key functionalities and features of Microsoft Azure.</p>
                    </li>
                </ul>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 img-box-container img-content">
                <div class="img-box-why-chosse">
                    <img src="../../../assets/images/services/4430764.jpg" loading="lazy"
                        alt="Product Web Development">
                </div>
            </div>
        </div>
    </div>

</section>